import { useEffect, useState } from 'preact/hooks';
import { currentRoute, getBreadcrumb } from '@/router';
import { openDrawer } from '@/store/ui';

/**
 * Верхняя панель мобильной оболочки.
 * Слева — гамбургер (drawer), по центру — заголовок раздела.
 * Корзина живёт в нижней навигации (таб «Корзина»), в топбаре её дублировать не нужно.
 * Скрывается при скролле вниз, появляется при скролле вверх (нативный паттерн).
 */
export function MobileTopBar() {
  const route = currentRoute.value;
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let lastY = window.scrollY;
    let ticking = false;

    function update() {
      const y = window.scrollY;
      const goingDown = y > lastY;
      // Прячем только если проскроллили заметно вниз и не у самого верха.
      if (goingDown && y > 64) setHidden(true);
      else if (!goingDown) setHidden(false);
      lastY = y;
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header class={`m-topbar ${hidden ? 'is-hidden' : ''}`}>
      <button type="button" class="m-topbar-btn" onClick={openDrawer} aria-label="Меню">
        <i class="fa-solid fa-bars" />
      </button>
      <div class="m-topbar-title">{getBreadcrumb(route)}</div>
      {/* Спейсер шириной с кнопку слева — чтобы заголовок остался по центру. */}
      <span class="m-topbar-btn" aria-hidden="true" />
    </header>
  );
}
